import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { EventShortSettingsState } from 'src/domains/sportsbook/trading/view/eventDetails/eventShortSettings/EventShortSettings.state';
import { EventDetailsOptionElement, EventDetailsOptions, SelectElement } from 'src/domains/sportsbook/trading/view/eventDetails/eventShortSettings/EventShortSettings.style';

type EventShortSettingsPropsType = {
    eventId: number
}

export const EventShortSettings = observer('EventShortSettings', (props: EventShortSettingsPropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new EventShortSettingsState(appState.sdkStaff, props.eventId));
    const event = appState.sdkStaff.models.getEvent(props.eventId);

    if (event === null) {
        return null;
    }

    const displayClassName = event.display ? 'select--big select--success' : 'select--big select--error';
    const activeClassName = event.active ? 'select--big select--success' : 'select--big select--error';

    return (
        <EventDetailsOptions className='event-details-options form'>
            <EventDetailsOptionElement className='element'>
                <div className='select-wrapper'>
                    <SelectElement
                        className={displayClassName}
                        name='display'
                        onChange={state.onDisplayChangeHandler}
                        value={event.display ? '1' : '0'}
                    >
                        <option value='1'>Show</option>
                        <option value='0'>Hide</option>
                    </SelectElement>
                </div>
            </EventDetailsOptionElement>

            <EventDetailsOptionElement className='element'>
                <div className='select-wrapper'>
                    <SelectElement
                        className={activeClassName}
                        name='active'
                        onChange={state.onActiveChangeHandler}
                        value={event.active ? '1' : '0'}
                    >
                        <option value='1'>Active</option>
                        <option value='0'>Suspended</option>
                    </SelectElement>
                </div>
            </EventDetailsOptionElement>
        </EventDetailsOptions>
    );
});
